import React from "react"
import { Button, Card, CardBody, Table } from "reactstrap"
import { OrderArrows, TierSelect } from "components/Common/SponsorBand/RowControls"
import { assetSrc } from "components/Common/SponsorBand/sponsorFields"
import { EVENT_SPONSOR_TIERS } from "./sponsorPayload"

// The sponsors as a list, under the band: the keyboard path to arranging it (the shared row
// controls), and the place where a sponsor is taken off the event.

const thumbStyle = {
  width: 48,
  height: 48,
  padding: 4,
  background: "#fff",
  border: "1px solid #eef2f4",
  borderRadius: 6,
  objectFit: "contain",
}

const SponsorsTable = ({ sponsors, disabled, onEdit, onRetier, onShift, onRemove }) => (
  <Card className="mb-3">
    <CardBody>
      <h6 className="mb-2">Sponsors on this event</h6>
      <p className="text-muted" style={{ fontSize: 13 }}>
        Everything on the section, top to bottom as the band reads left to right. The tier and the
        arrows move a sponsor without dragging.
      </p>

      {sponsors.length === 0 ? (
        <p className="text-muted mb-0">No sponsors yet. Add one from any tier above.</p>
      ) : (
        <Table responsive className="align-middle mb-0">
          <thead>
            <tr style={{ fontSize: 12 }}>
              <th>Logo</th>
              <th>Sponsor</th>
              <th>Tier</th>
              <th>Order</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {sponsors.map((sponsor, index) => {
              const first = index === 0 || sponsors[index - 1].category !== sponsor.category
              const last =
                index === sponsors.length - 1 || sponsors[index + 1].category !== sponsor.category

              return (
                <tr key={sponsor.id} style={{ fontSize: 13 }}>
                  <td>
                    <img src={assetSrc(sponsor.logoUrl)} alt="" style={thumbStyle} />
                  </td>
                  <td style={{ fontWeight: 600 }}>
                    {sponsor.name}
                    {sponsor.url ? (
                      <div className="text-muted" style={{ fontSize: 12, fontWeight: 400 }}>
                        {sponsor.url}
                      </div>
                    ) : (
                      <div className="text-muted" style={{ fontSize: 12, fontWeight: 400 }}>
                        no website — the plate will not be a link
                      </div>
                    )}
                  </td>
                  <td>
                    <TierSelect
                      row={sponsor}
                      tiers={EVENT_SPONSOR_TIERS}
                      value={sponsor.category}
                      disabled={disabled}
                      onRetier={onRetier}
                    />
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <OrderArrows
                      row={sponsor}
                      first={first}
                      last={last}
                      disabled={disabled}
                      onShift={onShift}
                    />
                  </td>
                  <td className="text-right" style={{ whiteSpace: "nowrap" }}>
                    <Button size="sm" color="link" disabled={disabled} onClick={() => onEdit(sponsor)}>
                      Edit
                    </Button>
                    <Button
                      size="sm"
                      color="link"
                      className="text-danger"
                      disabled={disabled}
                      onClick={() => onRemove(sponsor)}
                    >
                      Remove
                    </Button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      )}
    </CardBody>
  </Card>
)

export default SponsorsTable
